import { render } from "./NavbarElement.vue?vue&type=template&id=75a47505&scoped=true"
import script from "./NavbarElement.vue?vue&type=script&lang=js"
export * from "./NavbarElement.vue?vue&type=script&lang=js"

import "./NavbarElement.vue?vue&type=style&index=0&id=75a47505&scoped=true&lang=css"

import exportComponent from "/home/beatriz/Documents/GitHub/virtus_consult/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a47505"]])

export default __exports__